/** @internal */

/** @internal */
const OP_SUSPENDED_WARNING_DATA_START = "Start";

/** @internal */

/** @internal */
const OP_SUSPENDED_WARNING_DATA_PENDING = "Pending";

/** @internal */

/** @internal */
const OP_SUSPENDED_WARNING_DATA_DONE = "Done";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/**
 * State indicating that a test has not adjusted the clock.
 *
 * @internal
 */
const start = {
  _tag: OP_SUSPENDED_WARNING_DATA_START
};

/**
 * State indicating that a test has adjusted the clock but a fiber is still
 * running with a reference to the fiber that will display the warning
 * message.
 *
 * @internal
 */
const pending = fiber => {
  return {
    _tag: OP_SUSPENDED_WARNING_DATA_PENDING,
    fiber
  };
};

/**
 * State indicating that the warning message has already been displayed.
 *
 * @internal
 */
const done = {
  _tag: OP_SUSPENDED_WARNING_DATA_DONE
};

/** @internal */
const isStart = self => {
  return self._tag === OP_SUSPENDED_WARNING_DATA_START;
};

/** @internal */
const isPending = self => {
  return self._tag === OP_SUSPENDED_WARNING_DATA_PENDING;
};

export { OP_SUSPENDED_WARNING_DATA_DONE, OP_SUSPENDED_WARNING_DATA_PENDING, OP_SUSPENDED_WARNING_DATA_START, done, isPending, isStart, pending, start };
